/**
 * extractFQDN
 *
 * @description Extracts a normalized host (FQDN) from a URL-like string.
 * @param {string} value - URL-like string entered by the user.
 * @returns {string | undefined} - Normalized host when valid; otherwise undefined.
 *
 */
const extractFQDN = (value: string): string | undefined => {
  if (!value) {
    return undefined
  }

  const normalized = value.trim()
  const withoutProtocol = normalized.replace(/^https?:\/\//iu, "")
  const hostWithOptionalPort = withoutProtocol.split("/")[0].trim()
  const host = hostWithOptionalPort.split("?")[0].split("#")[0].split(":")[0]

  return host && /^[a-z0-9.-]+\.[a-z]{2,}$/iu.test(host) ? host : undefined
}

export default extractFQDN
